import React from "react";
import logo from "../../assets/images/Newsletter/images/cslogo1.png";
import bgHeader from "../../assets/images/Newsletter/images/bg-header.png";
import banner from "../../assets/images/Newsletter/banners/april-2023.jpg";
import sagar from "../../assets/images/Newsletter/images/sagar.jpg";
import Airoplan from "../../assets/images/Newsletter/April-2023/airoplan.jpg";
import Graph from "../../assets/images/Newsletter/April-2023/graph.jpg";
import Bank from "../../assets/images/Newsletter/April-2023/bank.jpg";
import Wonder4 from "../../assets/images/Newsletter/April-2023/wondeal4.jpg";
import Wonder5 from "../../assets/images/Newsletter/April-2023/wondeal5.jpg";
import Wonder6 from "../../assets/images/Newsletter/April-2023/wondeal6.jpg";
import Wonder7 from "../../assets/images/Newsletter/April-2023/wondeal7.jpg";
import Wonder8 from "../../assets/images/Newsletter/April-2023/wondeal8.jpg";
import Testimonial1 from "../../assets/images/Newsletter/April-2023/testimonial1.jpg";
import Testimonial2 from "../../assets/images/Newsletter/April-2023/testimonial2.jpg";
import Impact from "../../assets/images/Newsletter/April-2023/impact1.jpg";
import Visit1 from "../../assets/images/Newsletter/April-2023/visit1.jpg";
import Visit2 from "../../assets/images/Newsletter/April-2023/visit2.jpg";
import Visit3 from "../../assets/images/Newsletter/April-2023/visit3.jpg";
import Visit4 from "../../assets/images/Newsletter/April-2023/visit4.jpg";
import News1 from "../../assets/images/Newsletter/April-2023/news1.jpg";
import News2 from "../../assets/images/Newsletter/April-2023/news2.jpg";
import Casestudy from "../../assets/images/Newsletter/April-2023/casestudy.jpg";
import Cdpforecast from "../../assets/images/Newsletter/April-2023/cdpforecast.jpg";
import Wonder9 from "../../assets/images/Newsletter/April-2023/wondeal9.jpg";
import Andy from "../../assets/images/Newsletter/April-2023/andy.png";
import SamLevenson from "../../assets/images/Newsletter/April-2023/samlevenson.png";
import AD from "../../assets/images/Newsletter/April-2023/AD.jpg";
import Nishchal from "../../assets/images/Newsletter/April-2023/Nishchal.jpg";
import EmployeeAwards1 from "../../assets/images/Newsletter/April-2023/empaward1.jpg";
import EmployeeAwards2 from "../../assets/images/Newsletter/April-2023/empaward2.jpg";
import Holi from "../../assets/images/Newsletter/April-2023/holi.jpg";
import Birthday1 from "../../assets/images/Newsletter/April-2023/birthday1.jpg";
import Birthday2 from "../../assets/images/Newsletter/April-2023/birthday2.jpg";
import LeadershipAward from "../../assets/images/Newsletter/April-2023/leaderawdard.jpg";
import Welcome from "../../assets/images/Newsletter/April-2023/welcome.jpg";
import Event4 from "../../assets/images/Newsletter/April-2023/event4.jpg";
import Event5 from "../../assets/images/Newsletter/April-2023/event5.jpg";
import Event6 from "../../assets/images/Newsletter/April-2023/event6.jpg";
import Event7 from "../../assets/images/Newsletter/April-2023/event7.jpg";
import Motivation from "../../assets/images/Newsletter/April-2023/motivation.jpg";
import fb1 from "../../assets/images/Newsletter/images/fb1.png";
import tw1 from "../../assets/images/Newsletter/images/tw1.png";
import ln1 from "../../assets/images/Newsletter/images/ln1.png";
import ig1 from "../../assets/images/Newsletter/images/ig1.png";
import yt1 from "../../assets/images/Newsletter/images/yt1.png";
import Building from "../../assets/images/Newsletter/April-2023/bg-header.png";
const April2023 = () => {
  return (
    <>
      <>
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        {/*[if !mso]><!*/}
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        {/*<![endif]*/}
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <title>COMSENSE - NEWSLETTER April-2025</title>
        <link
          rel="shortcut icon"
          href="https://www.comsenseconsulting.com/images/ico/favicon.ico"
        />
        <style
          dangerouslySetInnerHTML={{
            __html:
              "\n    @import url(https://fonts.googleapis.com/css2?family=Cookie&display=swap);\n    @import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500&display=swap);\n\n    @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');\n\n    @font-face {\n      font-family: 'Century Gothic', sans-serif;\n      src: url(fonts/CenturyGothic.ttf);\n    }\n\n    html {\n      font-family: century-gothic, sans-serif;\n      font-family: \"Montserrat\", sans-serif;\n    }\n\n    .ReadMsgBody {\n      width: 100%;\n      background-color: #fff\n    }\n\n    .ExternalClass {\n      width: 100%;\n      background-color: #fff\n    }\n\n    .ExternalClass,\n    .ExternalClass div,\n    .ExternalClass font,\n    .ExternalClass p,\n    .ExternalClass span,\n    .ExternalClass td {\n      line-height: 100%\n    }\n\n    html {\n      width: 100%\n    }\n\n    body {\n      -webkit-text-size-adjust: none;\n      -ms-text-size-adjust: none;\n      margin: 0;\n      padding: 0;\n      font-family: 'Open Sans', Arial, Sans-serif !important;\n      font-family: \"Montserrat\", sans-serif !important;\n    }\n\n    table {\n      border-spacing: 0;\n      table-layout: fixed;\n      margin: 0 auto\n    }\n\n    table table table {\n      table-layout: auto\n    }\n\n    img {\n      display: block !important;\n      overflow: hidden !important\n    }\n\n    .yshortcuts a {\n      border-bottom: none !important\n    }\n\n    img:hover {\n      opacity: .9 !important\n    }\n\n    a {\n      color: red;\n      text-decoration: none\n    }\n\n    .textbutton a {\n      font-family: 'open sans', arial, sans-serif !important;\n      font-family: \"Montserrat\", sans-serif;\n    }\n\n    .btn-link a {\n      color: #fff !important\n    }\n\n    ul {\n      padding-inline-start: 20px\n    }\n\n    ol {\n      padding-inline-start: 20px\n    }\n\n    .mobile-responsive {\n      display: none\n    }\n\n    .image-reponsive {\n      float: left;\n      margin-left: 0;\n      margin-right: 25px;\n      margin-top: 10px\n    }\n\n    @media only screen and (max-width:640px) {\n      body {\n        margin: 0;\n        width: auto !important;\n        font-family: 'Open Sans', Arial, Sans-serif !important\n      }\n\n      .table-inner {\n        width: 90% !important;\n        max-width: 90% !important\n      }\n\n      .table-full {\n        width: 100% !important;\n        max-width: 100% !important;\n        text-align: center !important\n      }\n\n      #sagar img {\n        width: 50%\n      }\n\n      .mobile-responsive {\n        display: block\n      }\n\n      .desktop-view {\n        display: none\n      }\n\n      .image-reponsive {\n        float: unset;\n        margin: 0 auto 10px\n      }\n\n      @media only screen and (max-width:479px) {\n        body {\n          width: auto !important;\n          font-family: 'Open Sans', Arial, Sans-serif !important\n        }\n\n        .table-inner {\n          width: 90% !important;\n          text-align: center !important\n        }\n\n        .table-full {\n          width: 100% !important;\n          max-width: 100% !important;\n          text-align: center !important\n        }\n\n        u+.body .full {\n          width: 100% !important;\n          width: 100vw !important\n        }\n\n        #sagar img {\n          width: 50%\n        }\n      }\n    }\n  ",
          }}
        />
        <table
          className="full newsletter-emailer"
          width="100%"
          alignitems="center"
          cellSpacing={0}
          cellPadding={0}
        >
          <tbody>
            <tr>
              <td
                bgcolor="#333742"
                background={bgHeader}
                style={{
                  borderTop: "4px solid red",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
                align="center"
              >
                <table
                  className="table-full"
                  width={600}
                  style={{ maxWidth: 600 }}
                  border={0}
                  align="center"
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <tbody>
                    <tr>
                      <td
                        height={40}
                        valign="top"
                        style={{
                          fontFamily: "Open sans,arial,sans-serif",
                          fontSize: 10,
                          color: "#fff",
                          lineHeight: "24px",
                          textAlign: "center",
                        }}
                      >
                        If this newsletter is not displayed correctly, please{" "}
                        <a href="/" style={{ color: "#fff" }}>
                          <u>click here</u>
                        </a>
                        .
                      </td>
                    </tr>
                    <tr>
                      <td align="center">
                        <table
                          className="table-full"
                          align="centre"
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                        >
                          <tbody>
                            <tr>
                              <td align="center" style={{ lineHeight: 0 }}>
                                <img
                                  editable=""
                                  label="image"
                                  style={{
                                    display: "block",
                                    lineHeight: 0,
                                    fontSize: 0,
                                    border: 0,
                                  }}
                                  src={logo}
                                  width={160}
                                  alt="logo"
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td height={25} />
                    </tr>
                  </tbody>
                </table>
                <table
                  className="table-full"
                  width={600}
                  style={{ maxWidth: 600 }}
                  border={0}
                  align="center"
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <tbody>
                    <tr>
                      <td>
                        <img
                          editable=""
                          label="image"
                          style={{
                            display: "block",
                            lineHeight: 0,
                            fontSize: 0,
                            border: 0,
                          }}
                          src={banner}
                          width="100%"
                          alt="logo"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
        <repeater>
          <table
            className="full"
            align="center"
            bgcolor="#333742"
            width="100%"
            border={0}
            cellSpacing={0}
            cellPadding={0}
          >
            <tbody>
              <tr>
                <td align="center">
                  <table
                    className="table-full"
                    width={600}
                    style={{ maxWidth: 600 }}
                    border={0}
                    align="center"
                    cellPadding={0}
                    cellSpacing={0}
                  >
                    <tbody>
                      <tr>
                        <td bgcolor="#FFFFFF" align="center">
                          <table
                            className="table-inner"
                            width={550}
                            border={0}
                            align="center"
                            cellPadding={0}
                            cellSpacing={0}
                          >
                            <tbody>
                              <tr>
                                <td height={20} />
                              </tr>
                              <tr>
                                <td>
                                  <table
                                    width={150}
                                    className="table-full"
                                    border={0}
                                    align="left"
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          id="sagar"
                                          align="center"
                                          style={{ lineHeight: 0 }}
                                        >
                                          <img
                                            src={sagar}
                                            alt="icon"
                                            style={{
                                              width: 167,
                                              display: "block",
                                              lineHeight: 0,
                                              fontSize: 0,
                                              border: 0,
                                            }}
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  {/*[if (gte mso 9)|(IE)]>
                </td>
                <td>
                  <![endif]*/}
                                  <table
                                    width={25}
                                    align="left"
                                    border={0}
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td height={15} />
                                      </tr>
                                    </tbody>
                                  </table>
                                  {/*[if (gte mso 9)|(IE)]>
                </td>
                <td>
                  <![endif]*/}
                                  <table
                                    className="table-full"
                                    width={375}
                                    border={0}
                                    align="right"
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td height={90} />
                                      </tr>
                                      <tr>
                                        <td
                                          align="center"
                                          style={{
                                            border: "0 solid #fff",
                                            borderRadius: 4,
                                          }}
                                        >
                                          <table
                                            width="90%"
                                            border={0}
                                            align="center"
                                            cellPadding={0}
                                            cellSpacing={0}
                                          >
                                            <tbody>
                                              <tr>
                                                <td
                                                  valign="bottom"
                                                  style={{
                                                    fontFamily:
                                                      "Century gothic,arial,sans-serif",
                                                    fontSize: 24,
                                                    color: "#4a4a4a",
                                                    fontWeight: 100,
                                                    lineHeight: "30px",
                                                  }}
                                                >
                                                  From the CEO’s desk
                                                </td>
                                              </tr>
                                              <tr>
                                                <td height={10} />
                                              </tr>
                                              <tr>
                                                <td align="left">
                                                  <table
                                                    align="left"
                                                    width={30}
                                                    border={0}
                                                    cellSpacing={0}
                                                    cellPadding={0}
                                                  >
                                                    <tbody>
                                                      <tr>
                                                        <td
                                                          height={10}
                                                          style={{
                                                            borderBottom:
                                                              "3px solid red",
                                                          }}
                                                        />
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td height={20} />
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td height={20} />
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "24px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              Dear Friends,
                                              <br />
                                              <br />
                                              Every year, this quarter amazes me.
                                              It is fascinating to think that we
                                              are already in the first quarter of
                                              a new year, full of opportunities
                                              and new beginnings. At the same
                                              time, it is equally astonishing that
                                              we are also in the last quarter of a
                                              financial year, where companies and
                                              individuals scramble to meet their
                                              financial goals and deadlines before
                                              the year-end. The simultaneous
                                              coexistence of these two
                                              contrasting periods highlights the
                                              importance of how we perceive
                                              situations and what we choose to
                                              focus on. Having said that,
                                              personally for me, this is a
                                              particularly interesting time as it
                                              beautifully brings in both a sense
                                              of urgency and excitement in our
                                              lives.
                                              <br />
                                              <br />
                                              In the last financial year, we
                                              witnessed growth but at the same
                                              time, our profits were less compared
                                              to Q-o-Q the previous year. The main
                                              reason was our increased investment
                                              to align with our long-term goals.
                                              We also invested in product
                                              development and innovation centers
                                              which are in line with our Vision
                                              for growth and long-term
                                              sustainability.
                                              <br />
                                              <br />
                                              I am glad to inform you that we
                                              closed a few good deals in the last
                                              quarter including an e-Commerce
                                              company in the US. Our targeted
                                              focus on growth in US geography is
                                              seeing positive results.
                                              <br />
                                              <br />
                                              Internally, we are continually
                                              working on aligning people and
                                              processes for structured growth. We
                                              recently did an organization-wide
                                              department and leadership
                                              consolidation. The monthly offsite
                                              of the leadership team has also
                                              started which brings out great
                                              insights and actionable ideas that I
                                              am quite positive, will bring us
                                              closer to our Vision.
                                              <br />
                                              <br />
                                              We have also started internal
                                              Delivery Newsletters to keep our
                                              massively growing team aligned with
                                              the company’s Vision and action
                                              plans.
                                              <br />
                                              <br />
                                              With this, I leave you to read in
                                              detail about all our wins,
                                              victories, events, and top news that
                                              brewed within the company in the
                                              last quarter.
                                              <br />
                                              <br />
                                              Happy Reading!
                                              <br />
                                              <br />
                                              <strong>Sagar Babar</strong>
                                              <br />
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Won Deals
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                <strong>
                                                  Comsense Implements CDP For A
                                                  Leading Aviation Company In
                                                  India
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Airoplan}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                Comsense was awarded a project by
                                                a leading aviation company in
                                                India to consolidate data
                                                including sentiments, feedback,
                                                and transactions from multiple
                                                source systems into a single Data
                                                Lake and push the output into
                                                Netcore data platform. Comsense
                                                will use multiple data tables
                                                from Data Lake to create a robust
                                                SVOC and build marketing
                                                dashboards.
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                <strong>
                                                  Comsense Solution Aids Better
                                                  Insights For A Health, Beauty,
                                                  and Pharmacy Retailer in the US
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Graph}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                Comsense will help a US-based
                                                health and beauty product reseller
                                                build solution that provides
                                                revenue and inventory insights for
                                                sellers on Amazon and Walmart.
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                <strong>
                                                  A Leading General Insurance
                                                  Customer in India Uses
                                                  Comsense's Solution For Better
                                                  Insight Analytics
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Bank}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                Comsense will help a leading
                                                general insurance company in India
                                                generate customer insights for 2
                                                and 4 wheeler insurance.
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                <strong>
                                                  Comsense Built A Consolidated
                                                  Dashboard For Ladakh Government
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Wonder4}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                Comsense was awarded a project by
                                                the Government of Ladakh to build
                                                a consolidated dashboard based on
                                                multiple departments and schemes.
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                <strong>
                                                  Govt. of Rwanda awarded
                                                  Comsense a Project to Support
                                                  Govt. Business Intelligence
                                                  System
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Wonder5}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                Comsense grabbed an extended
                                                project to support GBIS system
                                                maintenance, incident management,
                                                monitoring, minor enhancements,
                                                and management of all GBIS assets
                                                and web presence.
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                <strong>
                                                  Comsense Won a Project From the
                                                  Ministry of Agriculture, Rwanda
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Wonder6}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                Rwanda&apos;s Ministry of
                                                Agriculture (MINAGRI) needed a
                                                web-based system to assist in the
                                                management, tracking, and control
                                                of grains stored in silos and
                                                warehouses to enable better
                                                management and inventory tracking
                                                across the country. Comsense will
                                                develop a solution to create an
                                                interface based on current manual
                                                operations that will also
                                                integrate with the MINAGRI MIS.
                                                We will build a secure
                                                open-source and customizable
                                                platform allowing integration and
                                                interoperability.
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                <strong>
                                                  A Leading Path Lab in India
                                                  Awarded Comsense a Project To
                                                  Implement Acoustic Campaign Tool
                                                  Across Channels
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Wonder7}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                Comsense was awarded a project by
                                                a leading path lab in India to
                                                enable Acoustic Campaign Tool for
                                                them to execute campaigns via
                                                Email and WhatsApp. Comsense will
                                                be working with 7 different
                                                departments within the
                                                organization to enable channels
                                                and execute campaigns.
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          <layout label="quote">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      className="table-full"
                      width={600}
                      style={{ maxWidth: 600 }}
                      border={0}
                      align="center"
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td bgcolor="#FFFFFF" align="center">
                            <table
                              className="table-inner"
                              width={550}
                              style={{ maxWidth: 550 }}
                              border={0}
                              align="center"
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    width={580}
                                    align="center"
                                    style={{
                                      fontFamily:
                                        "Open sans,arial,sans-serif",
                                      fontSize: 18,
                                      color: "red",
                                      lineHeight: "28px",
                                      fontWeight: 700,
                                      textAlign: "center",
                                    }}
                                  >
                                    Comsense Implements an Integration Project
                                    For A Leading Global Apparel Company
                                  </td>
                                </tr>
                                <tr>
                                  <td height={25} />
                                </tr>
                                <tr>
                                  <td
                                    width={580}
                                    align="center"
                                    style={{ lineHeight: 0 }}
                                  >
                                    <img
                                      style={{
                                        display: "block",
                                        lineHeight: 0,
                                        fontSize: 0,
                                        border: 0,
                                        width: "100%",
                                      }}
                                      src={Wonder8}
                                      alt="img"
                                      width="100%"
                                      height="auto"
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td height={25} />
                                </tr>
                                <tr>
                                  <td
                                    align="center"
                                    style={{
                                      fontFamily:
                                        "Open sans,arial,sans-serif",
                                      fontSize: 14,
                                      color: "#9b9b9b",
                                      lineHeight: "28px",
                                      textAlign: "justify",
                                    }}
                                  >
                                    <multiline label="content">
                                      Comsense won a deal to enable integration
                                      of Adobe analytics/Omniture with Acoustic
                                      Campaign for a leading global apparel
                                      company. As a part of the solution,
                                      Comsense will automate all event data such
                                      as cart abandonment, browse abandonment,
                                      and real-time recommendations, and will
                                      push it to marketing databases.
                                      <br />
                                      <br />
                                    </multiline>
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    width={580}
                                    align="center"
                                    style={{
                                      fontFamily:
                                        "Open sans,arial,sans-serif",
                                      fontSize: 18,
                                      color: "red",
                                      lineHeight: "28px",
                                      fontWeight: 700,
                                      textAlign: "center",
                                    }}
                                  >
                                    Comsense helps a consulting firm in India
                                    onboard the Acoustic tools
                                  </td>
                                </tr>
                                <tr>
                                  <td height={25} />
                                </tr>
                                <tr>
                                  <td
                                    width={580}
                                    align="center"
                                    style={{ lineHeight: 0 }}
                                  >
                                    <img
                                      style={{
                                        display: "block",
                                        lineHeight: 0,
                                        fontSize: 0,
                                        border: 0,
                                        width: "100%",
                                      }}
                                      src={Wonder9}
                                      alt="img"
                                      width="100%"
                                      height="auto"
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td height={25} />
                                </tr>
                                <tr>
                                  <td
                                    align="center"
                                    style={{
                                      fontFamily:
                                        "Open sans,arial,sans-serif",
                                      fontSize: 14,
                                      color: "#9b9b9b",
                                      lineHeight: "28px",
                                      textAlign: "justify",
                                    }}
                                  >
                                    <multiline label="content">
                                      A leading consulting firm in Bangalore
                                      needed help with onboarding for the
                                      Acoustic tools. Comsense will help them
                                      set up, execute and consult on 5 IP warm-up
                                      processes.
                                      <br />
                                      <br />
                                    </multiline>
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    align="center"
                                    style={{
                                      fontFamily:
                                        "Century gothic,arial,sans-serif",
                                      fontSize: 24,
                                      color: "#4a4a4a",
                                      fontWeight: 100,
                                      lineHeight: "30px",
                                    }}
                                  >
                                    <singleline label="title">
                                      Testimonials
                                    </singleline>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={20} />
                                </tr>
                                <tr>
                                  <td align="center">
                                    <table
                                      width={40}
                                      bgcolor="#FF0000"
                                      style={{ borderRadius: 10 }}
                                      border={0}
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td
                                            height={5}
                                            style={{
                                              lineHeight: 0,
                                              fontSize: 0,
                                            }}
                                          >
                                            &nbsp;
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={20} />
                                </tr>
                                <tr>
                                  <td align="center">
                                    <table
                                      className="table-full"
                                      width="100%"
                                      border={0}
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td width="48%" valign="top">
                                            <img
                                              src={Testimonial1}
                                              alt="img"
                                              width="100%"
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                              }}
                                            />
                                          </td>
                                          <td width="4%">&nbsp;</td>
                                          <td width="48%" valign="top">
                                            <img
                                              src={Testimonial2}
                                              alt="img"
                                              width="100%"
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                              }}
                                            />
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={20} />
                                </tr>
                                <tr>
                                  <td
                                    style={{ border: "2px solid #d2d2d2" }}
                                    align="center"
                                  >
                                    <table
                                      className="table-inner"
                                      width={500}
                                      border={0}
                                      align="center"
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              className="table-full"
                                              width="100%"
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    width="76%"
                                                    valign="top"
                                                    style={{
                                                      fontFamily:
                                                        "Open sans,arial,sans-serif",
                                                      fontSize: 16,
                                                      color: "#9b9b9b",
                                                      lineHeight: "28px",
                                                      fontWeight: 600,
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    <multiline label="quote">
                                                      <i>
                                                        "Everyone wants to live on
                                                        top of the mountain, but
                                                        all the happiness and
                                                        growth occurs while you
                                                        are climbing it"
                                                      </i>
                                                      <br />
                                                      <span
                                                        style={{
                                                          color: "#000",
                                                          fontFamily:
                                                            "Century Gothic",
                                                          fontSize: 14,
                                                          fontStyle: "normal",
                                                          fontWeight: 700,
                                                        }}
                                                      >
                                                        - Andy Rooney,
                                                      </span>
                                                      <br />
                                                      American Radio and
                                                      Television Writer
                                                    </multiline>
                                                  </td>
                                                  <td width="4%">&nbsp;</td>
                                                  <td
                                                    width="20%"
                                                    align="right"
                                                    valign="top"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      src={Andy}
                                                      alt="img"
                                                      width={115}
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                      }}
                                                    />
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={25} />
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          {/*  */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <br />
                                    <br />
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Tech Delivery Newsletter Started
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              Our Co-founder and Chief Growth
                                              Officer, Sushil Gujrathi started a
                                              monthly Tech Delivery Newsletter
                                              titled "Impact" implying of what the
                                              team at Comsense does daily -
                                              Positively impacting the Company,
                                              the Customers and the Employees.
                                              This newsletter gives a complete
                                              picture to all team members on the
                                              new projects, on-going projects,
                                              projects delivered successfully and
                                              the WIP deals.
                                              <br />
                                              <br />
                                              Here is the key highlights section
                                              giving a quantified snapshot of
                                              campaigns and assets from the impact
                                              newsletter:
                                              <br />
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Impact}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">News</singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Honorary Visits That Added Value
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              In the last quarter, we got several
                                              opportunities to connect with some
                                              influential industry leaders,
                                              thought leaders, and people who have
                                              inspired us in many ways. We are
                                              grateful to each of them for giving
                                              us their valuable time and sharing
                                              insights that are helping us move
                                              rigorously towards excellence
                                              <br />
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Visit of Mr. Rajesh Jain, Netcore
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Visit1}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              Comsense Technologies was incredibly
                                              fortunate to welcome the pioneer in
                                              the Internet landscape of India -
                                              Mr. Rajesh Jain, who is also the
                                              Founder &amp; Managing Director of
                                              Netcore Cloud. During his visit, he
                                              imparted invaluable wisdom on how to
                                              unlock success and answered the
                                              thought-provoking questions posed by
                                              the audience. His words challenged
                                              everyone to reconsider their
                                              strategies in their personal and
                                              professional lives.
                                              <br />
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Visit of Dr. Makrand Jawadekar
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Visit2}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              It was our absolute pleasure to have
                                              Dr. Makrand Jawadekar at our office
                                              in January. Dr. Jawadekar has served
                                              as the Director of Pfizer and has a
                                              wealth of knowledge in building
                                              external partnerships for
                                              drug-delivery technology solutions.
                                              His words of wisdom inspired
                                              everyone as he shared insights on
                                              being successful and tips on
                                              maintaining healthy habits.
                                              <br />
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          {/* Tech Delivery Newsletter + News */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          {/* Events & Celebrations */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Visit of Mr. Suresh Katta
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Visit3}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              Mr. Suresh Katta is the Founder
                                              and CEO of Saama Technologies - a
                                              company that collaborated with
                                              Pfizer during the pandemic to
                                              leverage their purpose-built
                                              Clinical analytics platform to
                                              expedite the clinical trial for
                                              the World's first COVID-19
                                              vaccine. We were fortunate to be
                                              visited by him, where he shared
                                              insightful advice on harmoniously
                                              pursuing our career passion while
                                              maintaining a healthy balance in
                                              our lives.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Visit of Mr. Sanjay Puri
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Visit4}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              Sanjay Puri, an investor, mentor,
                                              and activist, recently paid a
                                              visit to Comsense office and
                                              shared some valuable insights with
                                              the team. The dynamic
                                              entrepreneur, in particular,
                                              expressed his deep appreciation
                                              for the company's work, and
                                              imparted some pearls of wisdom
                                              regarding the key to success.
                                              According to Mr. Puri, the secret
                                              lies in bringing good people on
                                              board, treating them well, and
                                              ensuring that they are duly
                                              rewarded for their hard work and
                                              dedication. It's a simple
                                              formula, but one that has proven
                                              time and again to be highly
                                              effective in building winning
                                              teams and achieving business
                                              success.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          {/* Comsense Leadership Meets Netcore CEO North America */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <br />
                                    /tbody&gt;
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Comsense Leadership Meets Netcore
                                            CEO North America
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={News1}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              Comsense's Co-founders Sagar and
                                              Aniket met with Pratik Bhadra,
                                              CEO North America, Netcore &
                                              UNBXD, at their office in New
                                              York. The purpose of the meeting
                                              was to discuss the 2023 GTM
                                              strategy for the USA. Netcore’s
                                              and Comsense’s teams will be
                                              collaborating to explore new
                                              business opportunities as well as
                                              deepen engagement with existing
                                              clients - especially the leading
                                              footwear retailers. Netcore is
                                              strongly entrenched in the US with
                                              its offerings mostly revolving
                                              around MarTech. Comsense will
                                              bring its Data, Analytics, and CX
                                              expertise along with its newly
                                              launched AI- Powered CDP.
                                            </multiline>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          {/* Comsense Innovation Business Head meets Rwanda's MINAGRI Project Owner */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <br />
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Comsense Innovation Business Head
                                            meets Rwanda's MINAGRI Project Owner
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={15} />
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={News2}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              Comsense’s Business Head Neeraj
                                              Kumar did a site visit and a
                                              meeting with Mr. Kaiyranga, the
                                              project owner of Rwanda’s MINAGRI
                                              Project for Grain Storage. He
                                              understood the current process and
                                              internal working of silos and
                                              explained what role Comsense can
                                              play in aiding MINAGRI to leverage
                                              open-source technologies to
                                              achieve digital goals.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            Case Studies
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={15} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={15} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 10,
                                              color: "#9b9b9b",
                                              lineHeight: "18px",
                                            }}
                                          >
                                            Check Out Our Latest Case Study
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Casestudy}
                                              alt="case-study"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            Customer Data Platform Forecast
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={15} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Cdpforecast}
                                              alt="Cdpforecast"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              As we move further into the digital
                                              age, data has become an increasingly
                                              valuable commodity for businesses of
                                              all sizes. Customer Data Platforms
                                              (CDPs) have emerged as a key tool
                                              for companies looking to make the
                                              most of their customer data. Here
                                              are some CDP forecast trends to
                                              watch out for in 2023:
                                              <br />
                                              <br />
                                              Increased adoption of CDPs: CDP
                                              adoption has been steadily rising in
                                              recent years, and this trend is set
                                              to continue into 2023. As companies
                                              look for ways to improve customer
                                              engagement and retention, CDPs are
                                              becoming an increasingly attractive
                                              solution. In fact, according to a
                                              recent survey, the CDP market is
                                              expected to grow to $10.3 billion by
                                              2025.
                                              <br />
                                              <br />
                                              Greater focus on real-time data:
                                              With the increasing amount of data
                                              being generated, companies are
                                              beginning to realize the importance
                                              of real-time data in making informed
                                              business decisions. In 2023, we can
                                              expect to see more CDPs offering
                                              real-time data capabilities to help
                                              businesses stay ahead of the curve.
                                              <br />
                                              <br />
                                              Personalization at scale:
                                              Personalization has been a buzzword
                                              in the marketing industry for some
                                              time now, but in 2023, we can expect
                                              to see more businesses taking
                                              personalization to the next level
                                              with the help of CDPs. By leveraging
                                              the vast amounts of customer data
                                              available, CDPs can help businesses
                                              deliver personalized experiences at
                                              scale.
                                              <br />
                                              <br />
                                              Integration with other marketing
                                              technologies: CDPs are becoming
                                              increasingly important in the
                                              marketing technology stack, and in
                                              2023, we can expect to see more
                                              integration between CDPs and other
                                              marketing technologies such as
                                              Customer Relationship Management
                                              (CRM) systems and Marketing
                                              Automation Platforms (MAPs). This
                                              integration will help businesses
                                              streamline their marketing
                                              operations and create a more unified
                                              customer experience.
                                              <br />
                                              <br />
                                              From a data science perspective,
                                              CDPs offer a wealth of opportunities
                                              for businesses to leverage their
                                              customer data in more meaningful
                                              ways. With the rise of machine
                                              learning and artificial
                                              intelligence, CDPs can help
                                              companies gain valuable insights
                                              from their data and make more
                                              informed decisions. As CDP adoption
                                              continues to grow, we can expect to
                                              see even more innovation in this
                                              space, with new technologies and
                                              capabilities emerging to help
                                              businesses stay ahead of the
                                              competition.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            style={{ border: "2px solid #d2d2d2" }}
                                            align="center"
                                          >
                                            <table
                                              className="table-inner"
                                              width={500}
                                              border={0}
                                              align="center"
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td height={20} />
                                                </tr>
                                                <tr>
                                                  <td align="center">
                                                    <table
                                                      className="table-full"
                                                      width="100%"
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td
                                                            width="76%"
                                                            valign="top"
                                                            style={{
                                                              fontFamily:
                                                                "Open sans,arial,sans-serif",
                                                              fontSize: 16,
                                                              color: "#9b9b9b",
                                                              lineHeight: "28px",
                                                              fontWeight: 600,
                                                              textAlign: "left",
                                                            }}
                                                          >
                                                            <multiline label="quote">
                                                              <i>
                                                                &ldquo;Don&rsquo;t
                                                                watch the clock,
                                                                do what it does.
                                                                Keep going.&rdquo;
                                                              </i>
                                                              <br />
                                                              <span
                                                                style={{
                                                                  color: "#000",
                                                                  fontFamily:
                                                                    "Century Gothic",
                                                                  fontSize: 14,
                                                                  fontStyle:
                                                                    "normal",
                                                                  fontWeight: 700,
                                                                }}
                                                              >
                                                                - Sam Levenson,
                                                              </span>
                                                              <br />
                                                              American Writer,
                                                              Humorist, Journalist
                                                            </multiline>
                                                          </td>
                                                          <td width="4%">
                                                            &nbsp;
                                                          </td>
                                                          <td
                                                            width="20%"
                                                            align="right"
                                                            valign="top"
                                                            style={{
                                                              lineHeight: 0,
                                                            }}
                                                          >
                                                            <img
                                                              src={SamLevenson}
                                                              alt="Sam Levenson"
                                                              width={115}
                                                              style={{
                                                                display: "block",
                                                                lineHeight: 0,
                                                                fontSize: 0,
                                                                border: 0,
                                                              }}
                                                            />
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td height={20} />
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="associates-speak-title">
                                              Associates Speak
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "24px",
                                            }}
                                          >
                                            <multiline label="associates-speak-intro">
                                              See what our team members have to
                                              say about their Comsense
                                              experience.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              className="table-full"
                                              width="100%"
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    align="center"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      editable=""
                                                      label="associates-speak-abhishek"
                                                      src={AD}
                                                      alt="Abhishek Deshpande"
                                                      width="100%"
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                        width: "100%",
                                                      }}
                                                    />
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td height={35} />
                                                </tr>
                                                <tr>
                                                  <td
                                                    align="center"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      editable=""
                                                      label="associates-speak-nishchal"
                                                      src={Nishchal}
                                                      alt="Nishchal Jinturkar"
                                                      width="100%"
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                        width: "100%",
                                                      }}
                                                    />
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={40} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="associates-learn-title">
                                              Associates Learn
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "left",
                                            }}
                                          >
                                            <multiline label="associates-learn-intro">
                                              At Comsense, we believe that
                                              learning has no age and upgrading
                                              your knowledge and skill set is
                                              crucial for success.
                                              <br />
                                              <br />
                                              With a learning mindset as our base,
                                              we encourage team members to
                                              upgrade their skill set every
                                              quarter. In the previous quarter,
                                              many of our associates successfully
                                              completed various certifications.
                                              The top learners of the quarter
                                              were:
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 15,
                                              color: "#000",
                                              lineHeight: "26px",
                                              fontWeight: 700,
                                            }}
                                          >
                                            Certifications
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={12} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#4a4a4a",
                                              lineHeight: "26px",
                                              textAlign: "left",
                                            }}
                                          >
                                            <multiline label="certifications-list">
                                              <span style={{ color: "#1a3a5c" }}>
                                                PI 300 (Power BI)
                                              </span>{" "}
                                              : Hussain Asif Mahadik • Varada Pol
                                              • Prajakta Patil • Tejaswi Raje •
                                              Yash Badani • Akanksha Jadhav
                                              <br />
                                              <span style={{ color: "#1a3a5c" }}>
                                                SQL &amp; Salesforce Marketing
                                                Cloud Email Specialist
                                              </span>{" "}
                                              : Pradynya Malekar
                                              <br />
                                              <span style={{ color: "#1a3a5c" }}>
                                                Salesforce Marketing Cloud
                                                Consultant
                                              </span>{" "}
                                              : Shivkumar Dusad
                                              <br />
                                              <span style={{ color: "#1a3a5c" }}>
                                                Salesforce Marketign Cloud Email
                                                Specialist
                                              </span>{" "}
                                              : Tushar Rane
                                              <br />
                                              <span style={{ color: "#1a3a5c" }}>
                                                Tealeaf SaaS: Business Analyst
                                              </span>{" "}
                                              : Shobhit Patodia • Vijay Pujari •
                                              Sanket Chikhale
                                              <br />
                                              <span style={{ color: "#1a3a5c" }}>
                                                Acoustic Campaign Specialist
                                              </span>{" "}
                                              : Rakhi Ankar
                                              <br />
                                              <span style={{ color: "#1a3a5c" }}>
                                                MySQL
                                              </span>{" "}
                                              : Swapnali Anarse
                                              <br />
                                              <span style={{ color: "#1a3a5c" }}>
                                                Angular and Rest API
                                              </span>{" "}
                                              : Omkar Gaikwad
                                              <br />
                                              <br />
                                              We send our heartiest
                                              congratulations to each one of them!
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              paddingTop: 50,
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="awards-title">
                                              Awards
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Comsense Quarterly Awards
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              editable=""
                                              label="awards-quarterly-photo"
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={EmployeeAwards1}
                                              alt="Comsense Quarterly Awards"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="awards-quarterly-intro">
                                              Quarterly awards are our way of
                                              rewarding great performers, and also
                                              showing our appreciation for their
                                              excellent work. These awards always
                                              motivate the recipients and management
                                              alike. The awards for the previous
                                              quarter were declared in the last week
                                              of March. Here&apos;s a list of all the
                                              winners.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 16,
                                              color: "red",
                                              lineHeight: "24px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Rookie (Rising Star) Award
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={12} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="awards-rookie">
                                              <strong>Shubham Kadam</strong> and{" "}
                                              <strong>Sakshi Doddamani</strong> have
                                              shown an excellent drive and passion to
                                              learn and adapt to the organization. In
                                              a short span, they have taken up big
                                              responsibilities and showcased immense
                                              potential. Thus, they were rightfully
                                              chosen for the Rookie Awards for this
                                              quarter.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 16,
                                              color: "red",
                                              lineHeight: "24px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Star Performer Award
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={12} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="awards-star">
                                              By demonstrating hard work and
                                              dedication,{" "}
                                              <strong>Shreepad Bidwai</strong> and{" "}
                                              <strong>Yash Badani</strong>, have
                                              supported and delivered projects that
                                              have helped us grow. They have gone over
                                              and beyond their roles and hence, the two
                                              were chosen as the Star Performers.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 16,
                                              color: "red",
                                              lineHeight: "24px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            The Ace Contributor Award
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={12} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="awards-ace">
                                              We were thrilled to announce{" "}
                                              <strong>Vijay Pujari</strong>, and{" "}
                                              <strong>Neha Kushwaha</strong> as our Ace
                                              Contributors. We appreciate their effort
                                              and solution-driven mindset that brings
                                              positive outcomes to our projects.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 16,
                                              color: "red",
                                              lineHeight: "24px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Team Player Award
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={12} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="awards-team-player">
                                              At Comsense, we value and respect members
                                              who demonstrate excellent team spirit.
                                              This quarter&apos;s Team Player Award was
                                              rightfully given to{" "}
                                              <strong>Shailesh Waghmare</strong> and{" "}
                                              <strong>Shraddha Kale</strong> who have
                                              worked hard with a vision of helping their
                                              teams win. They have not only performed
                                              individually well, but have also helped
                                              their team members grow.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 16,
                                              color: "red",
                                              lineHeight: "24px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Customer Delight Award
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={12} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="awards-customer-delight">
                                              In line with our extensive focus on
                                              Customer Delight this year, we were happy
                                              to acknowledge the sincerity with which{" "}
                                              <strong>Anant Kadam</strong> and{" "}
                                              <strong>Tanuj Chourasia</strong> took
                                              customer experience to the next level.
                                              They truly deserve the customer delight
                                              award.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Long Service Award
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              editable=""
                                              label="awards-long-service-photo"
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={EmployeeAwards2}
                                              alt="Long Service Award"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="awards-long-service">
                                              There is nothing that beats loyalty and we
                                              are truly honored to have some members
                                              who have stayed with us through thick and
                                              thin. We are very proud of and thankful
                                              to <strong>Sumedh Pawaskar</strong>,{" "}
                                              <strong>Karan Mudliar</strong>, and{" "}
                                              <strong>Uddhav Solanke</strong> for
                                              completing 5 years with Comsense. We are
                                              happy to confer the Long Service Award to
                                              the three of them.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              paddingTop: 50,
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Leadership Award
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              editable=""
                                              label="leadership-award-photo"
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={LeadershipAward}
                                              alt="Leadership Award"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="leadership-award-body">
                                              Vishnu and Omkar were recognized for their
                                              exceptional leadership skills. This dynamic
                                              duo impressed their peers and superiors
                                              alike with their innovative ideas,
                                              unwavering commitment, and ability to bring
                                              out the best in their team. They embody the
                                              qualities of true leaders and have set the
                                              bar high for all those around them.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={35} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="welcome-aboard-title">
                                              Welcome Aboard
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              editable=""
                                              label="welcome-aboard-photo"
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Welcome}
                                              alt="Welcome Aboard"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="welcome-aboard-body">
                                              The year 2023 has started with fresh hiring.
                                              Though the world is witnessing many dark
                                              episodes of lay-offs, and despite the global
                                              economic pressures, we can proudly say that
                                              we are still growing and hiring.
                                              <br />
                                              <br />
                                              Sanket Chikale, Amit Mandhare, Umang
                                              Varshney, Rajat Rai, Shubham Chordia,
                                              Yogeshwar Nalabale, and Parth Vijaysenanai
                                              joined us in the first quarter of the new
                                              year.
                                              <br />
                                              <br />
                                              We extend a warm welcome to them and wish
                                              them a great journey with us!
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={35} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="events-celebrations-title">
                                              Events and Celebrations
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="events-celebrations-intro">
                                              Comsense is a place that is forever buzzing
                                              with fun, celebrations, activities, events,
                                              laughter, and tonnes of work. The last
                                              quarter witnessed all of it.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 16,
                                              color: "red",
                                              lineHeight: "24px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            SportsKeeda – A Spectacular Show of Sporting
                                            Spirit
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              editable=""
                                              label="sportskeeda-photo"
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Event4}
                                              alt="SportsKeeda"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="sportskeeda-body">
                                              The month of February, sometimes called the
                                              month of love, was the perfect time to
                                              profess our love for sports. We put on a
                                              sports-themed show, Sportskeeda, in our new
                                              office in Pune. All associates put together
                                              impressive displays, sprucing up their bays
                                              with their favorite sports posters,
                                              equipment, and merchandise. They also
                                              delivered incredible presentations about
                                              their favorite sport.
                                              <br />
                                              <br />
                                              The &lsquo;Cycling&rsquo; team raced to
                                              victory, while the &lsquo;Ice
                                              Skating&rsquo; and &lsquo;Golf&rsquo; teams
                                              earned accolades for their remarkable
                                              content and display, respectively.
                                              <br />
                                              <br />
                                              This event served as a testament to
                                              Comsense&apos;s expertise in delivering
                                              digital outcomes for Sports retail and gave
                                              an energizing glimpse into how strong bonds
                                              can be forged via teamwork!
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              lineHeight: "22px",
                                              fontWeight: 700,
                                            }}
                                          >
                                            <a
                                              href="https://www.linkedin.com/feed/update/urn:li:activity:7028399353278984192/"
                                              target="_blank"
                                              rel="noreferrer"
                                              style={{
                                                color: "red",
                                                textDecoration: "none",
                                              }}
                                            >
                                              Read More ›
                                            </a>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                              paddingTop: 50,
                                            }}
                                          >
                                            Comsense Premier League
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              editable=""
                                              label="cpl-photo"
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Event5}
                                              alt="Comsense Premier League"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="cpl-body">
                                              The most awaited event of the year is
                                              our annual cricket championship – The
                                              Comsense Premier League. This year&apos;s
                                              CPL was an electrifying battle
                                              throughout with a nail-biting finale
                                              that went down to the last run. Team
                                              Gladiators took home the trophy with
                                              Maverick Masterminds taking the
                                              runner-up place.
                                              <br />
                                              <br />
                                              The tournament was an exceptional event
                                              celebrating camaraderie at its best.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              lineHeight: "22px",
                                              fontWeight: 700,
                                            }}
                                          >
                                            <a
                                              href="https://www.linkedin.com/feed/update/urn:li:activity:7023172375143723009/"
                                              target="_blank"
                                              rel="noreferrer"
                                              style={{
                                                color: "red",
                                                textDecoration: "none",
                                              }}
                                            >
                                              Read More ›
                                            </a>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                              paddingTop: 50,
                                            }}
                                          >
                                            Women&apos;s Day Celebration
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              editable=""
                                              label="womens-day-photo"
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Event6}
                                              alt="Women’s Day Celebration"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="womens-day-body">
                                              Comsense has always believed in the
                                              power, creativity, and discipline that
                                              women bring to work and we have ample
                                              respect for them. To show how much we
                                              value our female team members, we
                                              celebrated International Women&apos;s Day
                                              at work. Apart from the usual, dress-up
                                              and lunch organized, we created a video
                                              of our women workforce with their
                                              powerful words that show the
                                              indomitable spirit of women.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              lineHeight: "22px",
                                              fontWeight: 700,
                                            }}
                                          >
                                            <a
                                              href="https://www.linkedin.com/feed/update/urn:li:activity:7039074753957031936/"
                                              target="_blank"
                                              rel="noreferrer"
                                              style={{
                                                color: "red",
                                                textDecoration: "none",
                                              }}
                                            >
                                              Watch The Video ›
                                            </a>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                              paddingTop: 50,
                                            }}
                                          >
                                            Sankranti Celebration
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              editable=""
                                              label="sankranti-photo"
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Event7}
                                              alt="Sankranti Celebration"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="sankranti-body">
                                              The festival of Sankranti is an
                                              auspicious occasion across India where
                                              we worship the Sun as per our ancient
                                              scriptures. The festivities and
                                              celebrations of Sankranti include
                                              prayers and offerings to the Sun God.
                                              Kite Flying is an important part of
                                              the celebrations of this festival.
                                              <br />
                                              <br />
                                              At Comsense&apos;s new office, we made the
                                              most of our huge terrace by organizing a
                                              kite flying event. All team members
                                              came dressed in traditional clothes and
                                              participated with enthusiasm, making it
                                              a fun-filled afternoon.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              lineHeight: "22px",
                                              fontWeight: 700,
                                            }}
                                          >
                                            <a
                                              href="https://www.instagram.com/reel/Cndp73ZImcE/?igshid=YmMyMTA2M2Y"
                                              target="_blank"
                                              rel="noreferrer"
                                              style={{
                                                color: "red",
                                                textDecoration: "none",
                                              }}
                                            >
                                              Watch The Celebration ›
                                            </a>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                              paddingTop: 20,
                                            }}
                                          >
                                            Holi Celebration
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              editable=""
                                              label="holi-photo"
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Holi}
                                              alt="Holi Celebration"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="holi-body">
                                              The festival of colors added vibrancy and
                                              cheer to our already exciting environment
                                              at work. Team members brought in
                                              eco-friendly colors and applied them to
                                              each other. Everyone also relished the
                                              snacks and sweets that we had in the
                                              office. Overall, it was a splash of color
                                              and festivity cheer everywhere.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              lineHeight: "22px",
                                              fontWeight: 700,
                                            }}
                                          >
                                            <a
                                              href="https://www.instagram.com/p/CpeR4eoLlqO/?igshid=YmMyMTA2M2Y%3D"
                                              target="_blank"
                                              rel="noreferrer"
                                              style={{
                                                color: "red",
                                                textDecoration: "none",
                                              }}
                                            >
                                              Read More ›
                                            </a>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={35} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                              paddingTop: 20,
                                            }}
                                          >
                                            Birthday Celebrations
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              editable=""
                                              label="birthday-cofounders-photo"
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Birthday1}
                                              alt="Birthday Celebrations"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="birthday-body-1">
                                              The month of March becomes extra special
                                              for us as we celebrate the birthdays of
                                              two important pillars, our Co-founders -
                                              Sagar and Sushil. Their birthdays provided
                                              us an opportunity to show our
                                              appreciation for their hard work,
                                              dedication, and contribution to the
                                              company. Their birthdays were celebrated
                                              by cutting cakes and team members coming
                                              up and showing their appreciation in
                                              words.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              editable=""
                                              label="birthday-team-photo"
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Birthday2}
                                              alt="Team Birthday Celebrations"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="birthday-body-2">
                                              In the last quarter, we also celebrated the
                                              birthdays of many team members.
                                              Celebrations took place for Bhakti Shinde,
                                              Tanvi Chaurasia, Nishchal Jinturkar, Shruti
                                              Mishra, Prajakta Patil, Apeksha Purvant,
                                              Sakshi Doddamani, Sanket Chikale, Vrushali
                                              Paralkar, Prajakta Mohite, Rohit Londhe,
                                              Sharayu Tambe, and Rajat Rai.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              paddingTop: 20,
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="spiritual-corner-title">
                                              Spiritual Corner
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              editable=""
                                              label="spiritual-corner-image"
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Motivation}
                                              alt="Spiritual Corner"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="spiritual-corner-body">
                                              We are delighted to inform our readers
                                              that Kamlesh Patel - renowned meditation
                                              guide, a best-selling author, and the
                                              current President of Heartfulness
                                              Organization has been conferred the
                                              prestigious Padma Bhushan - One of the
                                              highest civilian awards in the country.
                                              <br />
                                              <br />
                                              Through the Heartfulness mission, Daaji,
                                              as he is affectionately called, makes the
                                              meditation practice freely and easily
                                              accessible to millions of seekers in over
                                              160 countries and has developed
                                              value-based development programs for
                                              students and faculty in over 5,000
                                              schools, universities, and educational
                                              institutions.
                                              <br />
                                              <br />
                                              Comsense leadership has been following
                                              Heartfulness for more than a few decades
                                              and offer meditation sessions for those
                                              who are keenly interested.
                                              <br />
                                              <br />
                                              More about Heartfulness and Daaji:{" "}
                                              <a
                                                href="https://www.youtube.com/watch?v=wRvHjuiA4kk&feature=youtu.be"
                                                target="_blank"
                                                rel="noreferrer"
                                                style={{
                                                  color: "red",
                                                  textDecoration: "none",
                                                }}
                                              >
                                                https://www.youtube.com/watch?v=wRvHjuiA4kk&feature=youtu.be
                                              </a>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          <table
            className="full"
            bgcolor="#333742"
            align="center"
            width="100%"
            border={0}
            cellSpacing={0}
            cellPadding={0}
          >
            <tbody>
              <tr>
                <td align="center">
                  <table
                    className="table-full"
                    width={600}
                    style={{ maxWidth: 600 }}
                    border={0}
                    align="center"
                    cellPadding={0}
                    cellSpacing={0}
                  >
                    <tbody>
                      <tr>
                        <td
                          align="center"
                          background={Building}
                          bgcolor="#515663"
                          style={{
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                          }}
                        >
                          <table
                            align="center"
                            width="95%"
                            border={0}
                            cellSpacing={0}
                            cellPadding={0}
                          >
                            <tbody>
                              <tr>
                                <td height={20} />
                              </tr>
                              <tr>
                                <td
                                  align="center"
                                  style={{
                                    fontFamily:
                                      "Century gothic,arial,sans-serif",
                                    fontSize: 22,
                                    fontWeight: 600,
                                    lineHeight: "30px",
                                    color: "#fff",
                                    letterSpacing: 1,
                                  }}
                                >
                                  Thanks for reading.
                                  <br />
                                  <span
                                    style={{
                                      fontFamily:
                                        "Century gothic,arial,sans-serif",
                                      fontSize: 14,
                                      fontWeight: 400,
                                      color: "#fff",
                                      letterSpacing: 1,
                                    }}
                                  >
                                    Did someone share this with you?{" "}
                                    <a
                                      style={{ color: "#fff" }}
                                      href="https://www.comsenseconsulting.com/newsletter/subscribe.html"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <u>Sign up</u>
                                    </a>{" "}
                                    here.
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td height={15} />
                              </tr>
                              <tr>
                                <td align="center">
                                  <table
                                    align="center"
                                    border={0}
                                    cellSpacing={0}
                                    cellPadding={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          bgcolor="#FF0000"
                                          height={40}
                                          style={{
                                            fontFamily:
                                              "Century Gothic,sans-serif",
                                            fontSize: 14,
                                            color: "#4a4a4a",
                                            fontWeight: 700,
                                            paddingLeft: 15,
                                            paddingRight: 16,
                                            letterSpacing: "1.5px",
                                          }}
                                        >
                                          <a
                                            href="https://www.comsensetechnologies.com/newsletter/subscribe.html"
                                            style={{
                                              textDecoration: "none",
                                              color: "#fff",
                                              borderRadius: 5,
                                            }}
                                            target="_blank" rel="noreferrer"
                                          >
                                            SUBSCRIBE
                                          </a>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{
                                    fontFamily:
                                      "Century gothic,arial,sans-serif",
                                    fontSize: 11,
                                    fontWeight: 400,
                                    color: "#fff",
                                    letterSpacing: 1,
                                    textAlign: "center",
                                  }}
                                >
                                  <br />
                                  If you liked this Newsletter, please recommend
                                  it to someone you know.
                                  <br />
                                  Or why not even share it on Twitter or
                                  Linkedin? … enough right?
                                  <br />
                                  If you don’t want to receive future
                                  Newsletters, please click here to{" "}
                                  <a
                                    style={{ color: "#fff" }}
                                    href="https://www.comsensetechnologies.com/newsletter/unsubscribe.html"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <u>unsubscribe</u>
                                  </a>
                                  .<br />
                                  We will miss you!
                                  <br />
                                  <br />
                                  {/* View April 2024 Newsletter Here <a style=color:#fff
                  href=https://comsensetechnologies.com/wp-content/newsletter/april-2024/
                  target=_blank><u>here</u></a>. */}
                                </td>
                              </tr>
                              <tr>
                                <td height={20} />
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </repeater>
        <table
          className="full"
          bgcolor="#333742"
          align="center"
          width="100%"
          border={0}
          cellSpacing={0}
          cellPadding={0}
        >
          <tbody>
            <tr>
              <td align="center">
                <table
                  className="table-full"
                  width={600}
                  style={{ maxWidth: 600 }}
                  border={0}
                  align="center"
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <tbody>
                    <tr>
                      <td bgcolor="#FFFFFF" align="center">
                        <table
                          className="table-inner"
                          width={550}
                          style={{ maxWidth: 550 }}
                          border={0}
                          align="center"
                          cellPadding={0}
                          cellSpacing={0}
                        >
                          <tbody>
                            <tr>
                              <td height={25} />
                            </tr>
                            <tr>
                              <td
                                align="center"
                                style={{
                                  fontFamily: '"Open sans",Arial,sans-serif',
                                  color: "#4a4a4a",
                                  fontSize: 16,
                                }}
                              >
                                FOLLOW US
                              </td>
                            </tr>
                            <tr>
                              <td height={25} />
                            </tr>
                            <tr>
                              <td>
                                <table
                                  className="table-full"
                                  border={0}
                                  align="center"
                                  cellPadding={0}
                                  cellSpacing={0}
                                >
                                  <tbody>
                                    <tr>
                                      <td>
                                        <table
                                          border={0}
                                          align="center"
                                          cellPadding={0}
                                          cellSpacing={0}
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                              >
                                                <a
                                                  href="https://www.facebook.com/Comsenseconsulting/"
                                                  target="_blank" rel="noreferrer"
                                                >
                                                  <img
                                                    src={fb1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-1"
                                                  />
                                                </a>
                                              </td>
                                              <td width={20} />
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                                target="_blank"
                                              >
                                                <a href="https://twitter.com/ComsenseTech">
                                                  <img
                                                    src={tw1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-2"
                                                  />
                                                </a>
                                              </td>
                                              <td width={20} />
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                              >
                                                <a
                                                  href="http://linkedin.com/company/comsense-consulting"
                                                  target="_blank" rel="noreferrer"
                                                >
                                                  <img
                                                    src={ln1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-3"
                                                  />
                                                </a>
                                              </td>
                                              <td width={20} />
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                              >
                                                <a
                                                  href="https://www.instagram.com/comsensemktg/"
                                                  target="_blank" rel="noreferrer"
                                                >
                                                  <img
                                                    src={ig1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-4"
                                                  />
                                                </a>
                                              </td>
                                              <td width={20} />
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                              >
                                                <a
                                                  href="https://www.youtube.com/channel/UCCekynsEDZS7VORzB5KwX9g"
                                                  target="_blank" rel="noreferrer"
                                                >
                                                  <img
                                                    src={yt1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-5"
                                                  />
                                                </a>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                            <tr>
                              <td height={25} />
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td height={5} bgcolor="#FF0000" />
                    </tr>
                  </tbody>
                </table>
                <table
                  className="table-full"
                  width={600}
                  style={{ maxWidth: 600 }}
                  border={0}
                  align="center"
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <tbody>
                    <tr>
                      <td height={25} />
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </>
    </>
  );
};

export default April2023;
